"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapabilityContext = exports.CapabilityConfigurationProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function CapabilityConfigurationProvider({ children }) {
    const [disabledCapabilities, setDisabledCapabilities] = react_1.useState([]);
    const value = react_1.useMemo(() => ({ disabledCapabilities, setDisabledCapabilities }), [
        disabledCapabilities,
        setDisabledCapabilities,
    ]);
    return jsx_runtime_1.jsx(exports.CapabilityContext.Provider, Object.assign({ value: value }, { children: children }), void 0);
}
exports.CapabilityConfigurationProvider = CapabilityConfigurationProvider;
exports.CapabilityContext = react_1.createContext({
    disabledCapabilities: [],
    setDisabledCapabilities: (() => { }),
});
//# sourceMappingURL=index.js.map